import { APP_SCHEME, APPLE_STORE_URL, GOOGLE_PLAY_URL, OS_IOS } from "@/common";
import { ua } from "./deviceInfo";
import { getTenjinTrackUrlWithAttribution, jumpToAppStore } from "./tenjin";

export class YooFindsCallApp {
  private static getCallLib() {
    if (typeof window === "undefined") return null;
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const CallApp = require("callapp-lib");
    const callAppOptions = {
      scheme: {
        protocol: APP_SCHEME,
        host: APP_SCHEME,
      },
      appstore: APPLE_STORE_URL,
      googlePlay: GOOGLE_PLAY_URL,
      fallback:
        ua()?.getOS().name?.toLowerCase() == OS_IOS
          ? APPLE_STORE_URL
          : GOOGLE_PLAY_URL,
      timeout: 3000,
    };
    return new CallApp(callAppOptions);
  }

  /**
   * 跳转APP - 先尝试调起APP，失败后执行回调或跳转应用商店
   * @param options 跳转配置选项
   */
  static callOpenApp(
    path: string,
    callback?: (url: string) => void,
    deepLinkUrl?: string
  ) {
    const callLib = this.getCallLib();
    if (!callLib) return;
    const tenjinUrl = getTenjinTrackUrlWithAttribution(deepLinkUrl);
    callLib.open({
      path,
      callback: callback
        ? () => {
            callback(tenjinUrl);
          }
        : () => {
            jumpToAppStore(deepLinkUrl);
          },
    });
  }
}
